import { handleRequest } from "../utilities/requestHandler";

export const process2DModelFile = (requestData) => 
    handleRequest("post", "/models/process-2d-modelfile", requestData);

export const processModelFile = (requestData) => 
    handleRequest("post", "/models/process-modelfile", requestData);

export const verifyResourceExists = async (url) => {
    if (!url) return false;
    try {
        const response = await fetch(url, { method: "HEAD" });
        return response.ok;
    } catch (err) {
        console.error("Failed to verify resource:", err);
        return false;
    }
};
